import { memo, ReactNode, useCallback } from 'react'
import cn from 'classnames'
import { LayoutMobile } from 'components/extend/LayoutMobile'
import { ClickOutside } from 'components/helpers/ClickOutside'

import s from './DialogMobile.module.less'
import theme from './DialogMobileLayout.module.less'

interface IProps {
  children: ReactNode
  isCloseOnOutsideClick: boolean
  isDialogType: boolean
  isOffsets: boolean
  action?: ReactNode
  className?: string
  footer?: ReactNode
  footerClassName?: string
  header?: ReactNode
  headerAdditional?: ReactNode
  id?: string
  isShowCloseButton?: boolean
  onClose?: () => void
}

export const DialogMobile = memo<IProps>(function DialogMobile({
  action,
  children,
  className,
  footerClassName,
  footer,
  header,
  headerAdditional,
  id,
  isCloseOnOutsideClick,
  isShowCloseButton = true,
  isDialogType,
  isOffsets,
  onClose
}) {
  const handleClickOutside = useCallback(() => {
    if (isCloseOnOutsideClick && onClose) {
      onClose()
    }
  }, [isCloseOnOutsideClick, onClose])

  return (
    <ClickOutside className={className} id={id} onClickOutside={handleClickOutside}>
      <LayoutMobile
        action={action}
        className={s.DialogMobile}
        footer={footer}
        footerClassName={footerClassName}
        header={headerAdditional}
        isShowCloseButton={isShowCloseButton}
        onClose={onClose}
        theme={isDialogType ? theme : undefined}
        title={header}
      >
        <div className={cn({ [s.offset]: isOffsets })}>{children}</div>
      </LayoutMobile>
    </ClickOutside>
  )
})
